import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { BProps, DataTypeB0301 } from 'store/ducks/Reportings/types';
import { columnsB0301 } from 'constants/reportColumns';

const B0301: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0301[]>([]);
  const memoizedColumns = useMemo(() => columnsB0301, [columnsB0301]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData =
        await reportingOp.fetchContractualArrangementsLei(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            link: dataItem.zlink,
            arrangement_reference_number: dataItem.arrangement_reference_number,
            lei_entity_signing_contractual_arrangement:
              dataItem.lei_entity_signing_contractual_arrangement,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0301}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0301;
